import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * B-FORCE-PASSWORD (2026-07-29, operator) — belt-and-braces for the forced
 * password rotation.
 *
 * The auth guard redirects flagged users, but it reads the CACHED user in
 * localStorage: someone already signed in before the rollout has a cached
 * record with no flag, so the guard stays quiet while the server correctly
 * refuses every call with 423. That user saw an error and no way forward.
 *
 * This interceptor watches for the server's own verdict and sends them
 * straight to the set-password screen — no logout, no stale-cache problem.
 */
@Injectable()
export class PasswordChangeInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: any) => {
        const forced = err?.status === 423 || err?.error?.error_code === 'PASSWORD_CHANGE_REQUIRED';
        if (forced && !this.router.url.includes('set-new-password')) {
          this.router.navigateByUrl('/auth/set-new-password');
        }
        return throwError(() => err);
      })
    );
  }
}
